import { useEffect, useMemo } from 'react';
import { PageLoading } from '@dynamika-shared/ui/PageLoading/PageLoading';
import { useDICOMViewerSlice } from '@restore/DICOMViewer/DICOMViewer.slice';
import { EDTFDrawer } from '@dynamika-shared/components/EDTFDrawer/EDTFDrawer';
import { useQCTaskUploadsListSlice } from '@restore/QCTaskUploadsList/QCTaskUploadsList.slice';
import { useEDTFSlice } from '@restore/EDTF/EDTF.slice';
import { useSettingsSlice } from '@restore/settings/settings.slice';
import { useOHIFVersion } from 'src/hooks/useOHIFVersion';
import { UserRoles } from '@dynamika-shared/types/auth';
import { OHIFViewerModeType } from '@dynamika-shared/types/viewerMode';
import { getRpcSessionId } from '@dynamika/rpc-core/engine';

export const QCViewer = () => {
  const [viewerState, runViewer] = useDICOMViewerSlice((s, a) => [
    s.state,
    a.runViewer,
  ]);

  const { version: VERSION, isReady: isVersionReady } = useOHIFVersion(
    OHIFViewerModeType.IMAGING_SPECIALIST
  );

  const setDarkMode = useSettingsSlice((_, a) => a.setDarkMode);

  const IFrameUrl = `${window.location.origin}/viewer/${VERSION}/${window.location.search}`;
  const rpcSessionId = getRpcSessionId();

  const uploads = useQCTaskUploadsListSlice(s => s.data);

  /*
    todo: replace EDTF for
    1) QCVisit (Upload info)
    2) siteUser role
  */
  const [edtfData, resetEdtf, uploadId] = useEDTFSlice((s, a) => [
    s.data,
    a.reset,
    s.uploadId,
  ]);

  const activeUploadData = useMemo(
    () => uploads?.find(upload => upload.taskUploadId === uploadId),
    [uploads, uploadId]
  );

  useEffect(() => {
    runViewer({
      role: UserRoles.IMAGING_SPECIALIST,
      mode: OHIFViewerModeType.IMAGING_SPECIALIST,
    });
    setDarkMode(true);

    return () => {
      setDarkMode(false);
    };
  }, []);

  return (
    <div className='bg-eerieBlack w-full h-full'>
      {(['idle', 'loading'].includes(viewerState) || !isVersionReady) && (
        <div className='h-screen'>
          <PageLoading className='top-[50%]' />
        </div>
      )}
      {viewerState !== 'idle' && isVersionReady && (
        <div
          style={{
            visibility: viewerState === 'opened' ? 'visible' : 'hidden',
          }}
          className='fixed inset-0 flex w-full'
        >
          <div className={'w-full h-full bg-black'}>
            <iframe title='viewer' name={rpcSessionId} src={IFrameUrl} className='w-full h-full' />
          </div>
        </div>
      )}
      <EDTFDrawer
        dark
        uploadDateTime={activeUploadData?.uploadDate}
        edtfData={edtfData}
        isOpen={!!edtfData}
        onClose={() => {
          resetEdtf(undefined);
        }}
        siteUserName={activeUploadData?.siteUserName}
      />
    </div>
  );
};

export default QCViewer;
